import { find, reject, findIndex, cloneDeep } from 'lodash';
import store from 'store';
import moment from 'moment';
import { message } from 'antd';
import { guid, genFields } from '../utils/';
import { vendorQualificationCheck } from '../services/api';
import { saveFinishedStep } from '../views/Register/Basic';
import { qualificationFields } from '../constant/fields';

function gen() {
  return {
    tempId: guid(),
    ...genFields(qualificationFields),
    certificationStartDate: { value: null },
    certificationEndDate: { value: null },
  };
}
function init() {
  const initalQualificationData = [{
    ...gen(),
    // 默认第一个证书为营业执照 必填
    certificationType: { value: '005' },
    certificationName: { value: 'businessLicense' },
    isInit: true,
    editable: true,
    editQualification: true
  }];
  const cachedData = store.get('qualificationCache') && store.get('qualificationCache').map((data) => {
    // const { certificationStartDate, certificationEndDate } = data;
    // if (certificationStartDate.value && certificationEndDate.value) {
    //   data.certificationStartDate.value = moment(certificationStartDate.date);
    //   data.certificationEndDate.value = moment(certificationEndDate.date);
    // }
    // DatePicker要求null或moment对象 undefined不接受
    ['certificationStartDate', 'certificationEndDate'].forEach((key) => {
      data[key] = data[key] || {};
      data[key].value = data[key].value ? moment(data[key].value) : null;
    });
    return data;
  });
  return {
    qualificationData: cachedData || initalQualificationData,
  };
}
export default {
  namespace: 'qualificationRegister',
  state: init(),
  effects: {
    *pageInit(action, { put, select }) {
      const { companyCaterory } = yield select(s => s.companyInfoRegister.basicCompanyData);
      const isAgent = companyCaterory === 'Agent';
      yield put({
        type: 'ensureProxyCertificate',
        payload: { data: { isAgent } },
      });
    },
    *vendorQualificationCheck({ payload: { data, history } }, { call }) {
      const result = yield call(vendorQualificationCheck, data);
      if (result.success === true) {
        saveFinishedStep(4);
        history.push('/register/basic/step-five');
      } else {
        result.msg && message.error(result.msg);
      }
    },
    *addQualification(action, { put }) {
      const tempId = guid();
      yield put({
        type: 'addData',
        payload: { data: { tempId } },
      });
      return tempId;
    },
  },
  reducers: {
    updateState(state, { payload: { data } }) {
      return {
        ...state,
        ...data
      };
    },
    updateData(state, { payload: { data, cache } }) {
      const qualificationData = [...state.qualificationData];
      const index = findIndex(qualificationData, { tempId: data.tempId });
      qualificationData.splice(index, 1, data);
      if (cache) {
        // 存储到localstorage的时候moment对象会变化
        // const { certificationStartDate, certificationEndDate } = data;
        // if (certificationStartDate.value && certificationEndDate.value) {
        //   data.certificationStartDate.date = moment(certificationStartDate.value).valueOf();
        //   data.certificationEndDate.date = moment(certificationEndDate.value).valueOf();
        // }
        // DatePicker要求null或moment对象 undefined不接受
        ['certificationStartDate', 'certificationEndDate'].forEach((key) => {
          data[key] = data[key] || {};
          data[key].value = data[key].value ? moment(data[key].value) : null;
          data[key].date = data[key].date ? moment(data[key].date) : null;
        });
        store.set('qualificationCache', qualificationData);
      }

      return {
        ...state,
        qualificationData
      };
    },
    addData(state, { payload: { data: { tempId } } }) {
      const qualificationData = [...state.qualificationData];
      qualificationData.push({
        ...gen(),
        tempId,
        isInit: false,
        editable: true,
        editQualification: true
      });
      return {
        ...state,
        qualificationData
      };
    },
    deleteData(state, { payload: { data: { tempId } } }) {
      let qualificationData = [...state.qualificationData];
      qualificationData = reject(qualificationData, { tempId });
      store.set('qualificationCache', qualificationData);
      return {
        ...state,
        qualificationData
      };
    },
    ensureProxyCertificate(state, { payload: { data: { isAgent } } }) {
      const proxyCertificate = 'proxyCertificate';
      const certs = cloneDeep(state.qualificationData);
      const hasProxyCert = certs.some((item) => {
        return item.certificationName.value === proxyCertificate;
      });
      if (isAgent) {
        if (hasProxyCert) {
          const firstProxyCert = find(certs, (item) => {
            return item.certificationName.value === proxyCertificate;
          });
          firstProxyCert.isInit = true;
        } else {
          // 营业执照之后 第2位 插入
          certs.splice(1, 0, {
            ...gen(),
            certificationType: { value: '003' },
            certificationName: { value: proxyCertificate },
            isInit: true,
            editable: true,
            editQualification: true
          });
        }
      } else if (!isAgent && hasProxyCert) {
        // 不自动删除 而是转isInit为false 开放删除
        // certs = reject(certs, (item) => {
        //   return item.certificationName.value === proxyCertificate;
        // });
        certs.forEach((item) => {
          if (item.certificationName.value === proxyCertificate) {
            item.isInit = false;
          }
        });
      }
      return {
        ...state,
        qualificationData: certs,
      };
    },
    clear() {
      return init();
    }
  }
};
